import {
  ContractsEmployeesJobCatalogTreeFragment,
  ResourceFieldDataFragment,
  TaskDetailAffecteeReferenceContractFragment,
  TaskDetailContractContextlessPoliciesFragment,
  TaskDetailCustomFieldsContextlessPoliciesFragment,
  TaskDetailJobCatalogContextlessPoliciesFragment,
  ValueDataFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import AssigneesList from 'modules/tasks/components/AssigneesList'
import TaskDetails from 'modules/tasks/components/TaskDetails'
import { useGetTaskFiles } from 'modules/tasks/hooks/useGetTaskFiles'

import { TaskDetail } from './useTaskDetail'

interface ContentProps {
  task: TaskDetail
  canSeePersonalInfo: boolean
  canEditPersonalInfo: boolean
  canEmployeeManageAnyEmployeeFolder: boolean
  customResourceFieldsData: ResourceFieldDataFragment[]
  customValuesData: ValueDataFragment[]
  hasDevTimeTrackingWorkableDaysDefinition?: boolean
  hasTimeTrackingAnnualisationDailyValue?: boolean
  referenceContract?: TaskDetailAffecteeReferenceContractFragment | null
  jobCatalogContextlessPolicies: TaskDetailJobCatalogContextlessPoliciesFragment | undefined
  hasPayrollBundle: boolean
  contractContextlessPolicies: TaskDetailContractContextlessPoliciesFragment | undefined
  customFieldsContextlessPolicies: TaskDetailCustomFieldsContextlessPoliciesFragment | undefined
  jobCatalogTreeFeatureEnabled?: boolean
  jobCatalogTrees?: ContractsEmployeesJobCatalogTreeFragment[]
}

export const TaskElementContent = observer(
  ({
    task,
    canSeePersonalInfo,
    canEditPersonalInfo,
    canEmployeeManageAnyEmployeeFolder,
    customResourceFieldsData,
    customValuesData,
    hasDevTimeTrackingWorkableDaysDefinition,
    hasTimeTrackingAnnualisationDailyValue,
    referenceContract,
    jobCatalogContextlessPolicies,
    hasPayrollBundle,
    contractContextlessPolicies,
    customFieldsContextlessPolicies,
    jobCatalogTreeFeatureEnabled,
    jobCatalogTrees,
  }: ContentProps) => {
    const { files, loading } = useGetTaskFiles(task.id)

    const dueOn = task.dueOn

    return (
      <TaskDetails
        task={task}
        assignees={
          task.assignees?.length > 0 && (
            <AssigneesList count={task.assigneesCount} assignees={task.assignees} />
          )
        }
        affectee={task.affectees?.length > 0 && <AssigneesList assignees={task.affectees} />}
        dueOn={dueOn}
        files={files}
        loadingFiles={loading}
        canSeePersonalInfo={canSeePersonalInfo}
        canEditPersonalInfo={canEditPersonalInfo}
        canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
        customResourceFieldsData={customResourceFieldsData}
        customValuesData={customValuesData}
        hasDevTimeTrackingWorkableDaysDefinition={hasDevTimeTrackingWorkableDaysDefinition}
        hasTimeTrackingAnnualisationDailyValue={hasTimeTrackingAnnualisationDailyValue}
        referenceContract={referenceContract}
        jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
        hasPayrollBundle={hasPayrollBundle}
        contractContextlessPolicies={contractContextlessPolicies}
        customFieldsContextlessPolicies={customFieldsContextlessPolicies}
        jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
        jobCatalogTrees={jobCatalogTrees}
      />
    )
  }
)
